import { collection, getDocs } from "firebase/firestore";
import { db } from "@/firebase/firebaseConfig";
import { useEffect, useMemo, useState } from "react";
import ProductCard from "./ProductCard";
import { useAuth } from "@/utils/auth-context";
import EditProduct from "./AdminPanel/EditProduct";
import EditIcon from "./UI/EditIcon";
import Button from "./UI/Button";
import AddProduct from "./AdminPanel/AddProduct";
import { useNavigate } from "react-router-dom";
import InvestorModal from "@components/InvestorModal.jsx";

const ProductsList = () => {
  const [products, setProducts] = useState([]);
  const [openProduct, setOpenProduct] = useState(null);
  const [editProduct, setEditProduct] = useState(null);
  const [addProduct, setAddProduct] = useState(false);
  const adminId = "DyNgoxrjL3RtmQZyeeZ60maTo0F2";
  const { user, isVerified } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const isFormFilled = localStorage.getItem("isQuestionaryFilled");
    if (!isFormFilled) {
      navigate("/course/amazon/products");
    }
  }, [navigate]);

  const fetchProducts = async () => {
    try {
      const querySnapshot = await getDocs(collection(db, "products"));
      const fetchedProducts = [];

      for (const doc of querySnapshot.docs) {
        const productData = doc.data();

        if (productData.imageUrl) {
          const imageUrl = productData.imageUrl;

          fetchedProducts.push({
            id: doc.id,
            ...productData,
            imageUrl,
          });
        }
      }
      setProducts(fetchedProducts);
    } catch (error) {
      console.error("Ошибка при получении товаров с изображениями: ", error);
    }
  };

  useEffect(() => {
    fetchProducts();
  }, []);

  const sortedProducts = useMemo(() => {
    return products.sort((a, b) => a.name.localeCompare(b.name));
  }, [products]);

  console.log("OPEN PRODUCT:", openProduct);


  return (
    <>
      {user.uid === adminId && (
        <Button
          onClick={() => setAddProduct(true)}
          color="blue"
          title="Добавить новый товар"
        />
      )}

      <div className="products">
        {sortedProducts.map((product, index) => (
          <div
            key={product.id}
            className={`products-item  ${isVerified ? "" : "products-item--blur"}`}
            onClick={() => setOpenProduct(product)}
          >
            <img
              className="products-item__image"
              width={260}
              height={160}
              src={product.imageUrl}
              alt=""
            />
            <p className="products-item__title">
              <span> {index + 1} </span> / {product.name}
            </p>
            <p className="products-item__desc"> {product.style} </p>

            {user.uid === adminId && (
              <button
                className="products-item__adminBtn"
                onClick={(e) => {
                  e.stopPropagation(); // Предотвращает открытие карточки товара
                  setEditProduct(product);
                }}
              >
                <EditIcon color={"red"} />
              </button>
            )}
          </div>
        ))}

        {openProduct &&
          (isVerified ? (
            <div key={openProduct.id}>
              <ProductCard
                product={openProduct}
                onClose={() => setOpenProduct(null)}
              />
            </div>
          ) : (
            <InvestorModal
              text={`Доступ временно закрыт`}
              closeModal={() => setOpenProduct(false)}
            />
          ))}

        {editProduct && (
          <EditProduct
            id={editProduct?.id}
            key={editProduct?.id}
            product={editProduct}
            onClose={() => setEditProduct(null)}
          />
        )}

        {addProduct && <AddProduct onClose={() => setAddProduct(false)} />}
      </div>
    </>
  );
};

export default ProductsList;
